// extracted by mini-css-extract-plugin
export default {"summary":"oB","separator":"pB","title":"qB","note":"rB","items_wrapper":"sB","member_perk":"tB","info":"uB","extraQuestionsContain":"vB","h1":"wB","p":"xB","btn":"yB","stickyButton":"zB"};
    if(module.hot) {
      // 1726593106138
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  